import { combineReducers } from 'redux';
import A from './actionTypes';
import initialState from './initialState';

const zoom = (state = initialState, action ) => {
  if (action.type === A.ZOOM) {
    return action.payload;
  } else if (action.type === A.CHANGE_CENTER_AND_ZOOM) {
    return action.payload.zoom;
  } 
  return state;
};

const center = (state = initialState, action ) => {
  if (action.type === A.CHANGE_CENTER) {
    return action.payload;
  } else if (action.type === A.CHANGE_CENTER_AND_ZOOM) {
    return action.payload.center;
  } 
  return state;
};

const bounds = (state = initialState, action) => {
  if (action.type === A.CHANGE_BOUNDS) {
    return action.payload;
  }
  return state;
};

const selectedGravestone = (state = null, action) => (
  (action.type === A.SELECT_GRAVESTONE) ? action.payload : state
);

const gravestones = (state = initialState, action) => {
  return (action.type === A.LOAD_GRAVESTONES) ? action.payload: state
};

const aboutOpen = (state = initialState, action) => {
  if (action.type === A.TOGGLE_ABOUT) {
    return !state;
  }
  if (action.type === A.TOGGLE_CONTACT_US) {
    return false;
  }
  return state;
};

const contactUsOpen = (state = initialState, action) => {
  if (action.type === A.TOGGLE_CONTACT_US) {
    return !state;
  }
  if (action.type === A.TOGGLE_ABOUT) {
    return false;
  }
  return state;
};

const userLocation = (state = initialState, action) => {
  return (action.type === A.LOCATED_USER) ? action.payload : state
};

const hillshadeOn = (state = initialState, action) => {
  return (action.type === A.TOGGLE_HILLSHADE) ? !state : state;
};

const combinedReducer = combineReducers({
  selectedGravestone,
  gravestones,
  zoom,
  center,
  bounds,
  aboutOpen,
  contactUsOpen,
  userLocation,
  hillshadeOn,
});

export default combinedReducer;



// WEBPACK FOOTER //
// ./src/store/reducers.js